import { createActionCreator } from '@pressreader/appstore';
import { ILoginFlowContext, SignInDialogVersion } from '@pressreader/authentication-types';

import { AUTHENTICATION_CORE_MODULE_NAME } from '../../constants';

const prefix = `${AUTHENTICATION_CORE_MODULE_NAME}/login/`;

interface AuthenticationRequestPayload {
    dialogVersion?: SignInDialogVersion;
    introTextResourceId?: string;
    startWith?: ILoginFlowContext;
    disableClose?: boolean;
}

export const authenticationRequestAction = createActionCreator<AuthenticationRequestPayload>(`${prefix}authentication_request`);

export const authenticationDone = createActionCreator<{ authenticationResult: boolean }>(`${prefix}authentication_done`);

export const authenticationErrorEvent = createActionCreator<{ error: string }>(`${prefix}authentication_error`);

export const authenticationResendVerificationEmailAction = createActionCreator<{ email: string }>(`${prefix}resend_verification_email`);

export const maxNumberOfEmailsReachedEvent = createActionCreator(`${prefix}max_number_of_emails_reached`);

export const checkIsEmailVerifiedAction = createActionCreator<{ email: string; password: string }>(`${prefix}check_is_enail_verified`);
export const registrationEmailVerifiedEvent = createActionCreator(`${prefix}registration_status_updated`);
export const resetEmailVerifiedStatus = createActionCreator(`${prefix}reset_registration_status`);
